import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';
import bnTranslations from './locales/bn.json';
import hiTranslations from './locales/hi.json';
import guTranslations from './locales/gu.json';
import knTranslations from './locales/kn.json';
import mrTranslations from './locales/mr.json';
import paTranslations from './locales/pa.json';
import taTranslations from './locales/ta.json';
import teTranslations from './locales/te.json';
import mlTranslations from './locales/ml.json';
import orTranslations from './locales/or.json';
import asTranslations from './locales/as.json';

const resources = {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
    bn: { translation: bnTranslations },
    hi: { translation: hiTranslations },
    gu: { translation: guTranslations },
    kn: { translation: knTranslations },
    mr: { translation: mrTranslations },
    pa: { translation: paTranslations },
    ta: { translation: taTranslations },
    te: { translation: teTranslations },
    ml: { translation: mlTranslations },
    or: { translation: orTranslations },
    as: { translation: asTranslations },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
